/** */

import {
  ADD_MANY_EVENT_TO_STORE,
  ADD_ONE_EVENT_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_EVENTS_TO_STORE,
  REMOVE_MANY_EVENT_FROM_STORE,
  REMOVE_ONE_EVENT_FROM_STORE,
  UPDATE_ONE_EVENT_IN_STORE
} from '../actions/event';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_EVENT_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (events, event) => ({
            ...events,
            [event.id]: event
          }),
          {}
        )
      };
    case LOAD_EVENTS_TO_STORE:
      return {
        ...payload.reduce(
          (events, event) => ({
            ...events,
            [event.id]: event
          }),
          {}
        )
      };

    case REMOVE_MANY_EVENT_FROM_STORE:
      previous_state = { ...state };
      payload.forEach((id) => delete previous_state[id]);
      return {
        ...previous_state
      };

    case REMOVE_ONE_EVENT_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };

    case ADD_ONE_EVENT_TO_STORE:
      return {
        [payload.id]: payload,
        ...state
      };

    case UPDATE_ONE_EVENT_IN_STORE:
      return {
        ...state,
        [payload.id]: {
          ...state[payload.id],
          ...payload
        }
      };

    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (events, event) => ({
            ...events,
            [event.id]: event
          }),
          {}
        )
      };

    default:
      return state;
  }
};
